// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar-module--sidebar--X4z2p","sidebar--slim":"Sidebar-module--sidebar--slim--230LL","sidebar__inner":"Sidebar-module--sidebar__inner--Jdc5s"};